/* Reading positions.
 *
 * The lesson is a document, so stepping a block must not leave you mid-page:
 * every step lands on the top of the reader, under the sticky bar. Motion is a
 * preference, so a reduced-motion learner gets an instant jump instead.
 */
const NAV_FALLBACK = 64;

export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}

/* Must not be called scrollTo: that name replaces window.scrollTo. */
export function bringIntoView(top: number): void {
  window.scrollTo({ top, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
}

export function readerTop(): number {
  const reader = document.querySelector('.reader');
  if (!reader) return 0;
  const navHeight =
    parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-h'), 10) || NAV_FALLBACK;
  return Math.max(0, reader.getBoundingClientRect().top + window.scrollY - navHeight - 20);
}

export function scrollToReader(): void {
  bringIntoView(readerTop());
}

export function revealPanel(): void {
  const panel = document.querySelector('.panel');
  if (!panel) return;
  bringIntoView(panel.getBoundingClientRect().top + window.scrollY - 8);
}
